module.exports = __webpack_public_path__ + "static/img/cont3005.c3f0907.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3005.jpg
// module id = 081c
// module chunks = 0